import React from 'react';
import { Flex, Box, css, Embed } from 'theme-ui';
import ContentText from '@solid-ui-components/ContentText';
import ContentImages from '@solid-ui-components/ContentImages';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import styles from './styles';

const getListContent = (col, index) =>
  col.collection.slice(1).map((innerCol, innerIdx) =>
    innerCol.buttons ? (
      <li key={`article-col-${index}-${innerIdx}`}>
        <p css={css(styles.listP)}>
          {innerCol.text[0].text}{' '}
          <a
            css={css(styles.link)}
            target={innerCol.buttons[0]?.target}
            href={innerCol.buttons[0].link}
          >
            {innerCol.buttons[0].text}
          </a>{' '}
          {innerCol.text[1].text}
        </p>
      </li>
    ) : innerCol.text.length > 1 ? (
      <li key={`article-col-${index}-${innerIdx}`}>
        <p css={css(styles.listP)}>
          <span css={css(styles.listSpan)}>{innerCol.text[0].text}</span>{' '}
          {innerCol.text[1].text}
        </p>
      </li>
    ) : (
      <li key={`article-col-${index}-${innerIdx}`}>
        <p css={css(styles.listP)}>{innerCol.text[0].text}</p>
      </li>
    )
  );

const KnowledgeBaseArticleInfoBlock = ({
  content: { text, collection, buttons },
}) => (
  <Flex sx={styles.container}>
    <ContentText
      {...(buttons ? { id: buttons[0].link } : {})}
      sx={styles.title}
      content={text}
    />
    {collection.map((col, index) => (
      <Box key={`article-level-1-${index}`}>
        {col.text && <ContentText content={col.text} />}
        {col.collection && col.collection[0].text[0].text === 'ul' && (
          <ul>{getListContent(col, index)}</ul>
        )}
        {col.collection && col.collection[0].text[0].text === 'ol' && (
          <ol>{getListContent(col, index)}</ol>
        )}
        {col.collection && col.collection[0].text[0].text === 'link' && (
          <p css={css(styles.listP)}>
            {col.collection[1].text[0].text}{' '}
            <a
              css={css(styles.link)}
              target={col.collection[2].buttons[0]?.target}
              href={col.collection[2].buttons[0].link}
            >
              {col.collection[2].buttons[0].text}
            </a>{' '}
            {col.collection[1].text[1].text}
          </p>
        )}
        {col.collection && col.collection[0].text[0].text === 'video' && (
          <Box sx={{ my: 5 }}>
            <Embed src={col.collection[1].buttons[0].link} />
          </Box>
        )}
        {col.images && (
          <Box>
            <ContentImages
              sx={styles.imageContainer}
              content={{ images: col.images }}
            />
          </Box>
        )}
      </Box>
    ))}
  </Flex>
);

export default WithDefaultContent(KnowledgeBaseArticleInfoBlock);
